import * as React from 'react'
import MUIStepButton from '@mui/material/StepButton'

const StepButton = (props) => <MUIStepButton {...props} />

export default StepButton
